import type {TFunction} from 'i18next';
import moment from 'moment/moment';
import {z} from 'zod';

export const form600Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        finalAcknowledgement: z
            .boolean({message: `${t('mustAgree')}`})
            .nullable()
            .refine(val => val, {message: `${t('mustAgree')}`}),
        digitalSignature: z.string({message: `${t('sef600SigAdd')}`}).min(1, t('sef600SigAdd')),
        printedSignature: z.string({message: t('sef600PrintedSig')}).min(1, t('sef600PrintedSig')),
        signatureDate: z.custom<moment.Moment>(
            val => {
                return moment.isMoment(val) && val.isValid();
            },
            {
                message: 'Invalid Date',
            },
        ),
    });
